export const cleanTerminalString = (value = '') => {
  return value.replace(/\\?["']/g, '');
};
